import { TableControls } from "src/components/Table";

import { CAMPAIGN_SORTS, CAMPAIGN_STATUSES } from "./constants";

export default function CampaignListControls({
  onClickNewCampaign,
  createCampaignLoading,
  statusFilter,
  setStatusFilter,
  search,
  setSearch,
  sort,
  setSort
}: {
  onClickNewCampaign: () => Promise<void>;
  createCampaignLoading: boolean;
  statusFilter: string[];
  setStatusFilter: (newStatusFilter: string[]) => void;
  search: string;
  setSearch: (newSearch: string) => void;
  sort: string;
  setSort: (newSort: string) => void;
}): JSX.Element {
  return (
    <TableControls
      addButtons={[
        {
          label: createCampaignLoading
            ? "Creating Campaign..."
            : "New Campaign",
          onClick: onClickNewCampaign
        }
      ]}
      filters={[
        {
          label: "Campaign Status",
          value: statusFilter,
          onChange: setStatusFilter,
          options: CAMPAIGN_STATUSES.map(status => ({
            value: status.value,
            label: status.label
          })),
          multi: true
        }
      ]}
      sort={{
        value: sort,
        onChange: setSort,
        options: CAMPAIGN_SORTS.map(sort => ({
          value: sort.key,
          label: sort.label
        }))
      }}
      search={{
        value: search,
        onChange: setSearch,
        placeholder: "Search for a campaign..."
      }}
    />
  );
}
